module.exports = __webpack_public_path__ + "static/img/11.52cf71d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/zh/11.png
// module id = ZQIr
// module chunks = 0